/** SA-1126: the Roles page's words for permissions whose module is off on this deployment. */

export const UNAVAILABLE_RULE = 'Unavailable on this deployment'

export const NOT_ON_DEPLOYMENT = 'Not on this deployment'

export function heldText(count: number): string {
  return `${count} held`
}

export function gateTip(gate: string): string {
  return `Needs the ${gate} feature, which is off here. A role can keep it; nobody gets it until the feature is on.`
}
